import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { withRouter } from 'react-router-dom';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import './FeedviewsList.scss';

import AddButton from './AddButton';
import EditButton from './EditButton';

function FeedviewsList(props) {
  const { list, history, onDelete } = props;
  const options = useMemo(
    () => ({
      insertBtn: AddButton,
      defaultSortName: 'name',
      defaultSortOrder: 'asc',
    }),
    [],
  );

  const editFeedview = id => {
    history.push(`/feedview/${id}/config`);
  };

  const actionFormatter = (cell, feedview) => (
    <EditButton
      feedview={feedview}
      editFeedview={editFeedview}
      onDelete={onDelete}
    />
  );

  const feedCountFormatter = (cell, feed) => feed.Feeds?.length || 0;

  return (
    <div className="Feedviews-list-container">
      <BootstrapTable
        data={list}
        options={options}
        insertRow
        striped
        hover
        pagination
        bodyContainerClass="list-body-container"
        tableStyle={{ border: 'none' }}
      >
        <TableHeaderColumn isKey dataField="id">
          ID
        </TableHeaderColumn>
        <TableHeaderColumn
          dataField="name"
          dataSort
          filter={{ type: 'TextFilter', defaultValue: '' }}
        >
          Name
        </TableHeaderColumn>
        <TableHeaderColumn dataField="feed" dataFormat={feedCountFormatter}>
          Feed Count
        </TableHeaderColumn>
        <TableHeaderColumn
          dataField="button"
          columnClassName="list-action-column"
          dataFormat={actionFormatter}
        />
      </BootstrapTable>
    </div>
  );
}

FeedviewsList.propTypes = {
  list: PropTypes.array,
  history: PropTypes.object,
  onDelete: PropTypes.func,
};

export default withRouter(FeedviewsList);
